// extracted by mini-css-extract-plugin
export default {"cateGoryList":"cateGoryList_MBfi3","sidebarMode":"sidebarMode_rFVUK","mainListBox":"mainListBox_noJIZ","itemBox":"itemBox_OIY9p"};